/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 *
 * Token Constants - Configuration values for token management
 */

// ============================================================================
// TOKEN CONFIGURATION CONSTANTS
// ============================================================================

/**
 * Maximum concurrent token requests to prevent overwhelming Clerk
 */
export const MAX_CONCURRENT_TOKEN_REQUESTS = 3;

/**
 * Default fallback lifetime: 10 minutes (used only if token exp cannot be read)
 */
export const FALLBACK_TOKEN_CACHE_TTL_MS = 10 * 60 * 1000;

/**
 * Token fetch timeout
 * OPTIMIZATION: 15s allows Clerk enough time while preventing truly hung requests
 * Stale token fallback handles most timeout cases
 */
export const TOKEN_TIMEOUT_MS = 15000;

/**
 * Maximum retry attempts for transient failures
 */
export const TOKEN_MAX_RETRIES = 1;

/**
 * Initial delay before retry (exponential backoff: 500ms → 1000ms)
 */
export const TOKEN_RETRY_DELAY_MS = 500;

/**
 * Grace period for using recently expired tokens as fallback
 * 5 minutes - allows graceful degradation during token refresh
 */
export const STALE_TOKEN_GRACE_PERIOD_MS = 5 * 60 * 1000;

/**
 * Threshold for prefetching tokens before expiration
 * 5 minutes before expiration triggers background refresh
 */
export const PREFETCH_THRESHOLD_MS = 5 * 60 * 1000;

/**
 * Cleanup interval for expired tokens (runs every minute)
 */
export const TOKEN_CLEANUP_INTERVAL_MS = 60000;

/**
 * Clerk JWT template used for Supabase access tokens
 */
export const SUPABASE_JWT_TEMPLATE = "supabase";
